import React, { Component, createRef } from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import AudioConstants from "~/constants/Audio";
import Audio from "~/models/Audio";
import FormHelper from "~/utils/FormHelper";

@observer
class MusicSelector extends Component {
  audioRef = null;

  constructor(props) {
    super(props);

    this.state = {
      currentId: null,
      playing: false,
      showControls: false,
      src: "",
    };

    this.audioRef = createRef();
  }

  componentDidMount() {
    const { audios, nullValue } = this.props;

    // The component did mount is all about the customer default audio
    // If it is without audio, nothing to do
    if (nullValue === AudioConstants.CASCADING_NO_AUDIO_ID) {
      this.setState({ currentId: nullValue });
    } else {
      // We find the file and load without playing it
      const selectedAudio = audios.find(audio => audio.audioId === nullValue);

      if (typeof selectedAudio === "undefined") {
        return;
      }

      this.setState({
        src: selectedAudio.audioPathWeb,
        showControls: true,
      });

      this.audioRef.current.load();
    }
  }

  componentDidUpdate(prevProps) {
    const { newId } = this.props;

    if (typeof prevProps.newId !== "undefined" && newId !== prevProps.newId) {
      this.changeCurrentId(newId);
    }
  }

  changeCurrentId(newId) {
    const { nullValue } = this.props;
    const { currentId } = this.state;

    let newValue = FormHelper.convertToValue(newId);

    if (!newValue) {
      newValue = nullValue;
    }

    if (newValue === AudioConstants.CASCADING_NO_AUDIO_ID) {
      this.stop();

      this.setState({ showControls: false });

      return;
    }

    this.setState({
      showControls: true,
    });

    if (newValue === currentId) {
      this.toggle(newValue);
    } else {
      this.setState({
        currentId: newValue,
      });

      this.stop();
      this.play(newValue);
    }
  }

  play(currentId) {
    const { audios } = this.props;

    const selectedAudio = audios.find(audio => audio.audioId === currentId);

    if (typeof selectedAudio === "undefined") {
      return;
    }

    this.setState({
      playing: true,
      src: selectedAudio.audioPathWeb,
    });

    this.audioRef.current.load();
    this.audioRef.current.play();
  }

  stop() {
    this.audioRef.current.pause();
    this.setState({ playing: false });
  }

  toggle(currentId) {
    const { playing } = this.state;

    const newPlaying = !playing;

    this.setState({ playing: newPlaying });

    if (newPlaying) {
      this.play(currentId);
    } else {
      this.stop();
    }
  }

  render() {
    const { src, showControls } = this.state;

    return (
      // eslint-disable-next-line jsx-a11y/media-has-caption
      <audio ref={this.audioRef} controls controlsList="nodownload" style={{ opacity: showControls ? "1" : "0" }}>
        <source src={src} type="audio/mp3" />
      </audio>
    );
  }
}

MusicSelector.propTypes = {
  audios: PropTypes.arrayOf(PropTypes.instanceOf(Audio)),
  newId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  nullValue: PropTypes.number,
};

export default MusicSelector;
